import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EntryApiAdapter } from '../../adapters';
import { UpdateEntryAPIData } from '../../CreateEdit/models/CreateEntrySchema';

// Instancias singleton
const httpClient = createHttpClient(apiClientWH);
const entryApiAdapter = new EntryApiAdapter(httpClient);

interface UseUpdateEntryProps {
    entryId: number;
}

/**
 * Custom hook para actualizar una entrada existente
 */
export const useUpdateEntry = ({ entryId }: UseUpdateEntryProps) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: UpdateEntryAPIData) => {
            return entryApiAdapter.updateEntry(entryId, data);
        },
        onSuccess: (response) => {
            // Invalidar queries relacionadas
            queryClient.invalidateQueries({
                queryKey: ['entries']
            });

            // Actualizar cache específico solo si la respuesta contiene data
            // La API puede retornar 204 No Content sin body
            if (response?.data) {
                queryClient.setQueryData(['entry', entryId], response.data);
            } else {
                // Si es 204, invalidar la query para que se recargue
                queryClient.invalidateQueries({
                    queryKey: ['entry', entryId]
                });
            }
        },
        onError: (error: Error) => {
            console.error('❌ Error al actualizar entrada:', error);
        }
    });
};

